/**
 * Extracted from snippets/ns-navigation-panel-plunge-mobile.liquid (inline <script> at line 1271).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at snippets/ns-navigation-panel-plunge-mobile.liquid:1271) ---
(function () {
document.querySelectorAll('.ns-mb-plunge-menu .accordion').forEach(function(el) {
  el.addEventListener('click', function() {
    if (this.hasAttribute('open')) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }
  });
});

document.querySelector('.navigation-drawer [is="close-button"]')?.addEventListener('click', () => {
  document.querySelectorAll('.ns-mb-plunge-menu .accordion[open]').forEach(acc => {
    acc.removeAttribute('open');
  });
});

document.querySelectorAll('.ns-mega-menu-plunge-acc-title').forEach(function(el) {
  el.addEventListener('click', function() {
    if (this.hasAttribute('open')) {
      this.closest('.accordion').removeAttribute('open');
    } else {
      this.closest('.accordion').setAttribute('open', '');
    }
  });
});
const checkStars = setInterval(() => {
  const el = document.querySelector('.header-featured-section-text-reviews span.jdgm-prev-badge__stars');

  if (el) {
    const score = el.getAttribute('data-score');
    if (score === '5.00') {
      el.setAttribute('data-score', '5');
      el.setAttribute('aria-label', '5 stars');
    }
    clearInterval(checkStars); // Stop checking once done
  }
}, 500);
})();
